import { MediaData } from 'components/MediaViewer'
export enum CampaignPreviewActions {
    UPDATE_CAMPAIGN_INFORMATION_DATA = 'appPreview/UPDATE_CAMPAIGN_INFORMATION_DATA',
}

export interface UpdateCampaignInformationDataPayload {
    title?: string
    categories?: number[]
    images?: MediaData[]
    registration_enable?: boolean
    default_banner?: string
}

export const updateCampaignInformationData = (payload: UpdateCampaignInformationDataPayload) => ({
    payload,
    type: CampaignPreviewActions.UPDATE_CAMPAIGN_INFORMATION_DATA,
})
